import { ProfileInfo } from 'components/common/types'
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_FAILURE,
  FORGOT_PASSWORD_SUCCESS,
  LOGOUT_SUCCESS,
  PROFILE_INFO_REQUEST,
  PROFILE_INFO_SUCCESS,
  PROFILE_INFO_FAILURE,
  DELETE_ACCOUNT_SUCCESS
} from '../constants'

type IAuthReducer = {
  profileInfo: {
    data: ProfileInfo | null
    isLoading: boolean
    error: string | null
  }
  data: any
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
}

const initialState: IAuthReducer = {
  data: {},
  isAuthenticated: false,
  isLoading: false,
  error: null,
  profileInfo: {
    data: null,
    isLoading: true,
    error: null
  }
}

const AuthReducer = (
  state: IAuthReducer = initialState,
  action
): IAuthReducer => {
  switch (action.type) {
    case LOGIN_REQUEST:
    case SIGNUP_REQUEST:
    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true
      }

    case PROFILE_INFO_REQUEST:
      return {
        ...state,
        profileInfo: {
          ...state.profileInfo,
          isLoading: true
        }
      }

    case PROFILE_INFO_SUCCESS:
      return {
        ...state,
        profileInfo: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      }

    case PROFILE_INFO_FAILURE:
      return {
        ...state,
        profileInfo: {
          ...state.profileInfo,
          isLoading: false,
          error: action.payload
        }
      }

    case LOGIN_SUCCESS:
    case SIGNUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: !!action.payload.AccessToken,
        data: action.payload
      }

    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null
      }

    case SIGNUP_FAILURE:
    case LOGIN_FAILURE:
    case FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      }

    case LOGOUT_SUCCESS:
    case DELETE_ACCOUNT_SUCCESS:
      return initialState

    default:
      return state
  }
}

export default AuthReducer
